import { render, staticRenderFns } from "./justSign.vue?vue&type=template&id=8153856e&scoped=true"
import script from "./justSign.vue?vue&type=script&lang=js"
export * from "./justSign.vue?vue&type=script&lang=js"
import style0 from "./justSign.vue?vue&type=style&index=0&id=8153856e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8153856e",
  null
  
)

export default component.exports